"use strict";
exports.__esModule = true;
exports.DefaultDateFilterOption = exports.DefaultUserFilterOption = void 0;
var DefaultUserFilterOption;
(function (DefaultUserFilterOption) {
    DefaultUserFilterOption["CURRENT_USER"] = "${current_user}";
})(DefaultUserFilterOption = exports.DefaultUserFilterOption || (exports.DefaultUserFilterOption = {}));
var DefaultDateFilterOption;
(function (DefaultDateFilterOption) {
    DefaultDateFilterOption["TODAY"] = "${today}";
    DefaultDateFilterOption["YESTERDAY"] = "${yesterday}";
    DefaultDateFilterOption["THIS_WEEK"] = "${this_week}";
    DefaultDateFilterOption["LAST_WEEK"] = "${last_week}";
    DefaultDateFilterOption["THIS_MONTH"] = "${this_month}";
    DefaultDateFilterOption["LAST_MONTH"] = "${last_month}";
    DefaultDateFilterOption["THIS_YEAR"] = "${this_year}";
    DefaultDateFilterOption["LAST_YEAR"] = "${last_year}";
})(DefaultDateFilterOption = exports.DefaultDateFilterOption || (exports.DefaultDateFilterOption = {}));
